module.exports = new __parcel__URL__("albums.deb1d967.webp").toString();